import { HeadContactBook, Class } from '@/plugins/api'
export default {
  namespaced: true,
  state: {},
  actions: {
    async fetchData(_, params) {
      const res = await HeadContactBook.fetch({ ...params })
      return res
    },
    async fetchOwnClass(_, params) {
      const res = await Class.search({ ...params })
      return res
    }
  },
  mutations: {},
  getters: {}
}